export const buildRequestPrerequisites = ({ globalVariables, globalState }) => {
  const {
    environment: { ico_EdgeApiUrl, ico_Token, ico_EdgeApiKey, ico_UseBasicAuth }
  } = globalState
  const { traceId } = (globalVariables && globalVariables.current) || {}
  const headers = {
    QuestionConversion: 'fury',
    TraceId: traceId
  }
  if (ico_UseBasicAuth) headers.Authorization = `Basic ${ico_Token}`

  const baseUrl = ico_EdgeApiUrl
  return {
    headers,
    baseUrl,
    apiKey: ico_EdgeApiKey
  }
}

export const buildAuthTokenRequestPrerequisites = ({ globalVariables, globalState }) => {
  const {
    environment: { ico_EdgeApiUrl, ico_Token, ico_EdgeApiKey, ico_UseBasicAuth }
  } = globalState
  const { authToken, refreshToken, traceId } = globalVariables.current || {}
  const canConnect = authToken && !refreshToken
  const headers = {
    QuestionConversion: 'fury',
    TraceId: traceId
  }
  if (ico_UseBasicAuth) headers.Authorization = `Basic ${ico_Token}`
  if (authToken) headers.authtoken = authToken

  const baseUrl = ico_EdgeApiUrl
  return {
    headers,
    baseUrl,
    apiKey: ico_EdgeApiKey,
    canConnect
  }
}

export const checkRefreshTokenNeeded = data => data && data.meta && data.meta.codes.find(code => code === 403001 || code === 403002 || code === 403003)
